<template>
  <div style="background-color: #F6F8F9" class="opera-shirtReport">
    <topNav :title="$t('shirtReport_title')"></topNav>
    <datepik @change='getDate' ref="datepik" limit="pre" step="1"></datepik>
    <div class="ssearch">
      <div class="options mroption">
        <div class="parent " :class="{focus:this.selectedInput==1}">
          <input type="text" v-model='modelTwo' @touchstart="showPop(1)" readonly="readonly" @change="getData">
          <i class="iconfont icon-xia" @touchstart="showPop(1)"></i>
        </div>
      </div>
    </div>
    <div class="infoList">
      <div class="info">
        <div class="infoTop">
          <i class="iconfont icon-changfangxingbiaoqian"></i>
          {{$t('shirtReport_info')}}
        </div>
        <ul class="infoContent clearfix ">
          <template v-for="item in report.chargeList">
            <li :key="item.code">{{item.code}}
              <div class="right">{{item.name}}</div>
            </li>
          </template>
        </ul>
      </div>
      <div class="info">
        <div class="infoTop">
          <i class="iconfont icon-changfangxingbiaoqian"></i>
          {{$t('shirtReport_bill_info')}}
        </div>
        <ul class="infoContent clearfix ">
          <li v-for="item in report.payList" :key="item.code">{{item.code}}
            <div class="right">{{item.name}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show1" :selectData="newShirt" v-on:cancel="close(0)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
    <div class="pickerBox">
      <vue-pickers :show="show2" :selectData="userShirt" v-on:cancel="close(1)" v-on:confirm="confirmFn"></vue-pickers>
    </div>
  </div>
</template>
<script>
  import datepik from "../operaCommon/datepik";
  import moment from 'moment'
  import nothing from '../operaCommon/nothing'
  import {Toast} from 'mint-ui';
  import _ from 'lodash'
  import VuePickers from 'vue-pickers'

  export default {
    data() {
      return {
        seachOption: {
          code: '',//酒店范围代码（空时取当前）
          d: null,//日期（空时当前营业日）
          level: '',//酒店范围代码（可空）
          name: '',//i酒店范围的名称
          cashier: '',
          user: ''
        },
        hotelName: '',
        report: {},
        shirt: {},
        user: {},
        show1: false,
        show2: false,
        modelOne: this.$t("shirtReport_all_class"),//班别的默认值
        modelTwo: this.$t("shirtReport_all_user"),//人员默认值
        shirtArray: [],//shirt重组数据
        userArray: [],//user重组数据
        selectedInput: 6,//点击默认不显示高亮
        newShirt: {
          columns: 1,
          pData1: []
        },
        userShirt: {
          columns: 1,
          pData1: []
        },

      }
    },
    mounted() {
      this.getData();
      this.getParam();
      document.getElementsByClassName('pickerBox')[0].classList.add('noShow');
      document.getElementsByClassName('pickerBox')[1].classList.add('noShow');
      //使进入该页面滚动条在顶部，而不是中间段
      document.getElementsByClassName('shirtReport')[0].scrollTop = 0;
    },
    methods: {
      getData() {
        this.$http.post('/mobilepmsapi/opera/report/getShirtReport', this.seachOption).then(res => {
          if (res.data.result == 0) {
            this.report = res.data.retVal.data;
            this.seachOption.d = moment(res.data.retVal.search.d).format('YYYY-MM-DD');
            this.$refs.datepik.setDate(moment(res.data.retVal.search.d).toDate());
            this.hotelName = res.data.retVal.name;
          } else {
            Toast({
              message: res.data.msg,
              position: 'bottom',
              duration: 3000
            });
          }
        })
      },
      getParam() {
        this.$http.get('/mobilepmsapi/opera/report/getShirtReportUser').then(res => {
          if (res.data.result == 0) {
            this.user = res.data.retVal;
            this.newUser(this.user)
          }
        });
      },
      //重组user人员数组
      newUser(item) {
        this.userArray = [{text: this.$t("shirtReport_all_user"), value: ''}];
        for (let key in item) {
          this.userArray.push({
            text: item[key].name,
            value: item[key].code
          })
        }
        this.userShirt.pData1 = this.userArray
      },
      //点击input框效果
      showPop(val) {
        if (val == 0) {
          this.show1 = !this.show1;
        }
        if (val == 1) {
          this.show2 = !this.show2;
        }
        if (this.show1 == true || this.show2 == true) {
          document.getElementsByClassName('pickerBox')[val].classList.remove('noShow');
          document.addEventListener('touchmove', this.onHandler, false);//禁止滚动条滚动
          this.selectedInput = val;
          if (this.show1 == true && this.show2 == true) {
            for (var i = 0; i < 2; i++) {
              this.close(i);
            }
          }
        } else {
          this.close(val);
          document.removeEventListener('touchmove', this.onHandler, false);//开启滚动条滚动
        }
      },
      //弹框‘取消’按钮回调函数
      close(val) {
        this.show1 = false;
        this.show2 = false;
        document.removeEventListener('touchmove', this.onHandler, false);
        this.removeDown(val)
        this.selectedInput = 6;
      },
      //弹框隐藏
      removeDown(val) {
        document.getElementsByClassName('pickerBox')[val].classList.add('noShow');
      },
      //弹框‘确定’按钮回调函数
      confirmFn(data) {
        if (this.show1) {
          this.seachOption.cashier = data.select1.value;
          this.modelOne = data.select1.text;
          var val = 0;
        }
        if (this.show2) {
          this.modelTwo = data.select1.text;
          this.seachOption.user = data.select1.value;
          var val = 1;
        }
        document.removeEventListener('touchmove', this.onHandler, false);
        this.selectedInput = 6;
        this.getData();
        this.close(val);
      },
      getDate(time) {
        this.seachOption.d = time;
        // console.log(time)
        this.getData()
      },
      getHotel(hotel) {
        this.seachOption.code = hotel.code;
        // console.log(hotel.code)
        this.getData()
      },
    },
    filters: {},
    components: {
      datepik,
      nothing,
      VuePickers
    }
  }
</script>
<style lang='less'>
  .opera-shirtReport {

    .caterTop {
      margin: 0 0.5333rem;
      height: 0.4rem;
      color: #333;
      margin-top: 0.32rem;
      overflow: hidden;

      .left {
        float: left;

        span {
          margin-left: 0.1333rem;
        }
      }

      .right {
        float: right;

        span {
          margin-left: 0.1333rem;
          color: #d0011b;
        }
      }
    }

    .ssearch {
      clear: both;
      width: 92%;
      margin: 0.2667rem auto;
      height: 0.64rem;
    }

    .right {
      float: right
    }

    .infoList {
      width: 92%;
      clear: both;
      margin: 0.2667rem auto;
      background-color: #fff;
      padding-bottom: 0.5333rem;
      box-shadow: 0 0 1px 0;

      .info {
        padding: 0.2667rem 0;

        .infoTop {
          padding: 0 0.48rem;
          position: relative;
          height: 0.5333rem;
          line-height: 0.5333rem;

          .icon-changfangxingbiaoqian {
            position: absolute;
            font-size: 0.32rem;
            left: 0;
            top: 1px;
            color: #f6a624;
          }
        }

        .infoContent {
          margin: 0 0.5333rem;
          padding: 0.2667rem 0;
          border-bottom: 1px dashed #ddd;

          li {
            height: 0.5333rem;
            line-height: 0.5333rem;

            .infoVal {
              margin-left: 0.2133rem;
            }

            &.twocol {
              width: 50%;
              float: left;
            }
          }

          &.twocol {
            overflow: hidden;

            li {
              width: 50%;
              float: left;
            }
          }
        }

        .totalmoney {
          margin: 0 0.5333rem;
          height: 0.8rem;
          line-height: 0.8rem;
          border-bottom: 1px dashed #ddd;

          span {
            margin-left: 0.5333rem;
          }
        }
      }
    }

    .options {
      box-sizing: border-box;
      width: 2.5rem;
      height: 0.64rem;
      float: left;
      border: 1px solid #ccc;
      text-align: left;
      line-height: 0.64rem;
      outline: none;
      border: none;

      .parent {
        position: relative;
        width: 2.5rem;
        padding-left: 0.2667rem;
        height: 0.64rem;
        background: #fff;
        border: 1px solid #e8e8e8;

        &.focus {
          border: 1px solid #e0b47b;

          .iconfont {
            color: #e0b47b;
          }
        }

        input {
          border: none;
          width: 100%;
          line-height: 0.6133rem;
          // height: 24px;
          box-sizing: border-box;
        }

        .iconfont {
          position: absolute;
          right: 0.08rem;
          top: 0px;
        }
      }

    }

    .mroption {
      margin: 0 auto;
    }
  }

  .shirtReport .noShow {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// shirtReport.vue?2b452095